import analytics from '@/store/modules/analytics/analytics'
import analyticCreate from '@/store/modules/analytics/analytic-create'
import analyticEdit from '@/store/modules/analytics/analytic-edit'
import analyticDelete from '@/store/modules/analytics/analytic-delete'

export default {
  analytics,
  analyticCreate,
  analyticEdit,
  analyticDelete
}
